/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Resend_BodyInputs */

const tr_mesafeli_s11_resend_body = /** @type {(inputs: Mesafeli_S11_Resend_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşlemsel e-posta gönderimi; e-postaların açılma ve tıklama ölçümü dahil.`)
};

const en_mesafeli_s11_resend_body = /** @type {(inputs: Mesafeli_S11_Resend_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transactional email delivery, including open and click measurement.`)
};

const de_mesafeli_s11_resend_body = /** @type {(inputs: Mesafeli_S11_Resend_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand transaktionaler E-Mails, einschließlich Öffnungs- und Klickmessung.`)
};

const ru_mesafeli_s11_resend_body = /** @type {(inputs: Mesafeli_S11_Resend_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка транзакционных писем, включая учёт открытий и кликов.`)
};

/**
* | output |
* | --- |
* | "Transactional email delivery, including open and click measurement." |
*
* @param {Mesafeli_S11_Resend_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_resend_body = /** @type {((inputs?: Mesafeli_S11_Resend_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Resend_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_resend_body(inputs)
	if (locale === "de") return de_mesafeli_s11_resend_body(inputs)
	if (locale === "ru") return ru_mesafeli_s11_resend_body(inputs)
	return tr_mesafeli_s11_resend_body(inputs)
});